import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Button,
    VStack,
    Text,
    Box,
    OrderedList,
    ListItem,
    Icon,
    Flex
} from '@chakra-ui/react';
import { ArrowUpIcon, AddIcon, CheckIcon } from '@chakra-ui/icons';
import { getTranslations } from '../translations';

/**
 * Modale che mostra istruzioni per installare la PWA
 * Contenuto dinamico basato sulla piattaforma rilevata
 */
const InstallModal = ({ isOpen, onClose, platform }) => {
    const t = getTranslations();

    // Contenuto per iOS
    const renderIOSInstructions = () => (
        <VStack spacing={4} align="stretch">
            <Text fontSize="md" color="gray.600">
                {t.installIosIntro || 'Per installare questa app sulla tua schermata Home:'}
            </Text>
            <OrderedList spacing={3} pl={2}>
                <ListItem>
                    <Flex align="center" gap={2}>
                        <Icon as={ArrowUpIcon} boxSize={5} color="blue.500" />
                        <Text>{t.installIosStep1}</Text>
                    </Flex>
                </ListItem>
                <ListItem>
                    <Flex align="center" gap={2}>
                        <Icon as={AddIcon} boxSize={4} color="blue.500" />
                        <Text>{t.installIosStep2}</Text>
                    </Flex>
                </ListItem>
                <ListItem>
                    <Flex align="center" gap={2}>
                        <Icon as={CheckIcon} boxSize={4} color="green.500" />
                        <Text>{t.installIosStep3}</Text>
                    </Flex>
                </ListItem>
            </OrderedList>
            <Box bg="blue.50" p={3} borderRadius="md" mt={2}>
                <Text fontSize="sm" color="blue.800">
                    💡 {t.installIosTip || 'L\'icona Condividi si trova in basso al centro (Safari) o in alto a destra.'}
                </Text>
            </Box>
        </VStack>
    );

    // Contenuto per Android
    const renderAndroidInstructions = () => (
        <VStack spacing={4} align="stretch">
            <Text fontSize="md" color="gray.600">
                {t.installAndroid}
            </Text>
            <Box bg="green.50" p={3} borderRadius="md">
                <Text fontSize="sm" color="green.800">
                    💡 {t.installAndroidTip || 'Cerca l\'icona "Installa" o "Aggiungi a Home" nel menu del browser (⋮).'}
                </Text>
            </Box>
        </VStack>
    );

    // Contenuto per Desktop (macOS/Windows)
    const renderDesktopInstructions = () => (
        <VStack spacing={4} align="stretch">
            <Text fontSize="md" color="gray.600">
                {t.installDesktop}
            </Text>
            <Box bg="purple.50" p={3} borderRadius="md">
                <Text fontSize="sm" color="purple.800">
                    💡 {t.installDesktopTip || 'In Chrome o Edge, cerca l\'icona di installazione (⊕ o 💻) nella barra degli indirizzi a destra.'}
                </Text>
            </Box>
        </VStack>
    );

    // Seleziona il contenuto in base alla piattaforma
    const renderContent = () => {
        switch (platform?.os) {
            case 'ios':
                return renderIOSInstructions();
            case 'android':
                return renderAndroidInstructions();
            case 'macos':
            case 'windows':
            case 'linux':
                return renderDesktopInstructions();
            default:
                return (
                    <Text color="gray.600">
                        {t.installGeneric || 'Usa il menu del tuo browser per installare questa app.'}
                    </Text>
                );
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
            <ModalOverlay />
            <ModalContent mx={4}>
                <ModalHeader>{t.installTitle}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    {renderContent()}
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="brand" onClick={onClose} width="full">
                        {t.installClose}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default InstallModal;
